import React from 'react'
import ProductTagsEditor from '../components/products/ProductTagsEditor'

export default function Products() {
  return <ProductTagsEditor />
}
